export default "__VITE_ASSET__BcdRK4Jj__"